<template>
  <div class="select-time-container">
    <div class="select-time-row">
      <div class="select-time-control">
        <label class="control-label">Horário</label>
        <Select v-model="time" :options="timeList" :disabled="disabled" />
      </div>
    </div>

    <div class="select-time-row">
      <div class="select-time-control">
        <label class="control-label">Entrada</label>
        <input ref="entrada" 
               type="time" 
               class="form-control" 
               v-model="entrada"
               :disabled="inputDisable" 
               @change="update"
               @blur="lockIfValueIsNull">
      </div>
      <div class="select-time-control">
        <label class="control-label">Saida</label>
        <input ref="saida" 
               type="time" 
               class="form-control" 
               v-model="saida"
               :disabled="inputDisable" 
               @change="update" 
               @blur="lockIfValueIsNull">
      </div>
    </div>
  </div>
</template>

<script>
import Select from '@/components/common/Select'
import { lockIfValueIsNull } from '@/utils/events'

export default {
  components: {
    Select
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: () => { return false }
    }
  },
  created() {
    this.entrada = this.value.entrada
    this.saida = this.value.saida
  },
  data() {
    return {
      timeList: [
        { label: '08h - 18h', value: '08:00|18:00' },
        { label: '07h - 13h', value: '07:00|13:00' },
        { label: '07h - 16h', value: '07:00|16:00' },
        { label: '12h - 18h', value: '12:00|18:00' },
        { label: '13h - 19h', value: '13:00|19:00' },
        { label: '07h - 19h', value: '07:00|19:00' },
        { label: '19h - 07h', value: '19:00|07:00' },
        { label: 'Outros', value: 'outros' }
      ],
      time: '',
      entrada: '00:00',
      saida: '00:00',
      inputDisable: true
    }
  },
  watch: {
    time(value) {
      this.inputDisable = value !== 'outros'

      if (value === 'outros') {
        this.timeInfocus()
      }

      if (value.length === 0 || !this.inputDisable) {
        this.resetTime()
        return
      }

      if (this.inputDisable) {
        const [entrada, saida] = value.split('|')
        this.setTime({ entrada, saida })
      }
    },
    value: {
      handler(value) {
        const { entrada, saida } = value
        if (entrada === '' && saida === '') {
          this.time = ''
        } else if (entrada === '' || saida === '') {
          this.time = 'outros'
        } else {
          const value = `${entrada}|${saida}`
          const timeListValues = this.timeList.map(t => t.value)

          if (timeListValues.includes(value)) {
            this.time = value
          } else {
            this.time = 'outros'
          }
        }
      },
      deep: true
    }
  },
  methods: {
    setTime({ entrada, saida }) {
      this.entrada = entrada
      this.saida = saida
      this.update()
    },
    clearTime() {
      this.resetTime()
      this.update()
    },
    resetTime() {
      this.entrada = this.saida = ''
    },
    update() {
      const { entrada, saida } = this
      if (entrada.length > 0 || saida.length > 0) {
        this.$emit('input', { entrada, saida })
      }
    },
    timeInfocus () {
      setTimeout(() => this.$refs.entrada.focus(), 200);
    },
    lockIfValueIsNull
  }
}
</script>

<style scoped>
.select-time-container {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
}
.select-time-container div.select-time-row {
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.select-time-container div.select-time-control {
  width: 100%;
}
.select-time-container div.select-time-control:not(:first-child) {
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/SelectTime.vue